
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppImageHolder } from '@/components';
import { useTournamentMedalEdit } from '@/modules/tournament/medal/model/edit';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';

export default defineComponent({
    name: ROUTE_NAME_TOURNAMENT.MEDAL.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppImageHolder },
    setup() {
        const { model, v$, fetch, actions } = useTournamentMedalEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, fetch, actions };
    }
});
